"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const style = __importStar(require("./styled"));
const useOnOutsideClick_1 = require("@/Hooks/useOnOutsideClick");
const Hooks_1 = require("@/Hooks");
const Typography_1 = __importStar(require("@/Components/UI/Typography"));
const FavoriteShiptoOption_1 = __importDefault(require("./FavoriteShiptoOption"));
const FavoriteShiptosSelect = ({ options, onChange, onAdd, onRemove, disabled }) => {
    const placeholder = '/haldex/favorite_shipping_address/add_address';
    const noResults = '/haldex/favorite_shipping_address/no_results';
    const label = '/haldex/login_modal/shipp_for';
    const { t } = (0, Hooks_1.useTranslate)();
    const [open, setOpen] = (0, react_1.useState)(false);
    const [searchOptions, setSearchOptions] = (0, react_1.useState)(options);
    const [search, setSearch] = (0, react_1.useState)('');
    const selectRef = (0, react_1.useRef)(null);
    const [loadingOptions, setLoadingOptions] = (0, react_1.useState)([]);
    const inputRef = (0, react_1.useRef)(null);
    const ignoreNextFocusRef = (0, react_1.useRef)(false);
    const getShpiptoFullName = (option) => {
        return {
            displayName: `${option.name} ${option.city} - ${option.customerId}`,
            value: `${option.name.toLowerCase()} ${option.city.toLowerCase()} - ${option.customerId.toLowerCase()}`
        };
    };
    (0, react_1.useEffect)(() => {
        if (options) {
            setSearchOptions(options);
        }
    }, [options]);
    const handleOpen = () => {
        if (ignoreNextFocusRef.current) {
            ignoreNextFocusRef.current = false;
            return;
        }
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleChangeSearch = (e) => {
        const searchValue = e.currentTarget.value;
        setSearch(searchValue);
        if (!search) {
            setSearchOptions(options);
            return;
        }
        setSearchOptions(options.filter(option => getShpiptoFullName(option).value.includes(searchValue.toLowerCase())));
    };
    const handleSelectOption = (option) => {
        var _a;
        onChange(option);
        const shiptoFullName = getShpiptoFullName(option);
        setSearch(shiptoFullName.displayName);
        ignoreNextFocusRef.current = true;
        handleClose();
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    };
    const handleToggleFavorite = (value) => (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        e.stopPropagation();
        setLoadingOptions(prevState => [...prevState, value]);
        if (value.isFavorite) {
            yield onRemove(value);
        }
        else {
            yield onAdd(value);
        }
        setLoadingOptions(prevState => prevState.filter(item => item.customerId !== value.customerId));
    });
    const getIsOptionLoading = (optionId) => {
        return loadingOptions.some(({ customerId }) => customerId === optionId);
    };
    (0, useOnOutsideClick_1.useOnOutsideClick)(selectRef, handleClose);
    (0, Hooks_1.useEscape)(handleClose);
    return (react_1.default.createElement(style.Select, null,
        react_1.default.createElement(style.Label, null,
            react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.LABEL_ON_FORM },
                t(label),
                react_1.default.createElement(style.Required, null, "*"))),
        react_1.default.createElement(style.SelectContainer, { ref: selectRef },
            react_1.default.createElement(style.SelectHeader, null,
                react_1.default.createElement(style.SelectHeaderInput, { ref: inputRef, disabled: disabled, autoComplete: "off", placeholder: t(placeholder), type: "text", value: search, onChange: handleChangeSearch, onFocus: handleOpen }),
                react_1.default.createElement(style.SelectHeaderButton, { role: "button", tabIndex: 0, onClick: () => setOpen(!open), type: "button" },
                    react_1.default.createElement(style.Arrow, { isOpen: open }))),
            open && (react_1.default.createElement(style.DropdownListContainer, null,
                !searchOptions.length && t(noResults),
                searchOptions
                    .filter(option => option.isFavorite)
                    .map((option, index, arr) => (react_1.default.createElement(FavoriteShiptoOption_1.default, { isFavorite: option.isFavorite, isLoading: getIsOptionLoading(option.customerId), onToggleFavorite: handleToggleFavorite(option), onSelectOption: () => handleSelectOption(option), isLast: index === arr.length - 1, key: option.customerId + 'favorite', displayName: getShpiptoFullName(option).displayName }))),
                searchOptions
                    .filter(option => !option.isFavorite)
                    .map(option => (react_1.default.createElement(FavoriteShiptoOption_1.default, { isFavorite: option.isFavorite, isLoading: getIsOptionLoading(option.customerId), onToggleFavorite: handleToggleFavorite(option), onSelectOption: () => handleSelectOption(option), key: option.customerId, displayName: getShpiptoFullName(option).displayName }))))))));
};
exports.default = FavoriteShiptosSelect;
